import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword, clearResetPasswordStatus } from '../../store/slices/authSlice';
import './ForgotPasswordForm.scss';

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState('');
  const [isValid, setIsValid] = useState(true);
  const dispatch = useDispatch();
  const { resetEmailSent, status, error } = useSelector((state) => state.auth);

  // Detailed logging on component mount and unmount
  useEffect(() => {
    console.log('[ForgotPasswordForm] Component mounted');
    console.log('[ForgotPasswordForm] Initial state:', { email, isValid });
    console.log('[ForgotPasswordForm] Redux state:', { resetEmailSent, status, error });
    
    return () => {
      console.log('[ForgotPasswordForm] Component unmounting');
      dispatch(clearResetPasswordStatus());
      console.log('[ForgotPasswordForm] Reset status cleared');
    };
  }, []);

  // Log state changes
  useEffect(() => {
    console.log('[ForgotPasswordForm] Redux state updated:', { resetEmailSent, status, error });
  }, [resetEmailSent, status, error]);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const result = regex.test(email);
    console.log(`[ForgotPasswordForm] Email validation: "${email}" is ${result ? 'valid' : 'invalid'}`);
    return result;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(`[ForgotPasswordForm] Submit clicked with email: ${email}`);
    
    if (!email.trim()) {
      console.log('[ForgotPasswordForm] Empty email submitted');
      setIsValid(false);
      return;
    }

    if (validateEmail(email)) {
      console.log('[ForgotPasswordForm] Dispatching resetPassword action');
      dispatch(resetPassword(email));
      console.log('[ForgotPasswordForm] resetPassword dispatched');
    } else {
      console.log('[ForgotPasswordForm] Invalid email format');
      setIsValid(false);
    }
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    console.log(`[ForgotPasswordForm] Email changed to: ${newEmail}`);
    setEmail(newEmail);
    setIsValid(true); // Reset validation on change
  };

  console.log('[ForgotPasswordForm] Rendering with state:', { 
    email, isValid, resetEmailSent, status, error 
  });

  return (
    <div className="forgot-password-form">
      <h2>Reset Your Password</h2>
      
      {resetEmailSent ? (
        <div className="success-message">
          <p>Password reset email sent! Check your inbox for further instructions.</p>
          <p className="email-sent-to">Email sent to: {email}</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={handleEmailChange}
              className={!isValid ? 'invalid' : ''}
              placeholder="Enter your email"
            />
            {!isValid && <p className="error-message">Please enter a valid email address</p>}
          </div>
          
          {error && <p className="auth-error">{error}</p>}
          
          <button 
            type="submit" 
            className="reset-button"
            disabled={status === 'loading'}
          >
            {status === 'loading' ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
      )}
    </div>
  );
};

export default ForgotPasswordForm; 